import React, { useRef, useCallback, useEffect, useState } from "react";
import { DinamicSelect, DivFormGroup, DivInput, LabelInput } from "./styles";
import ConsultaTotvs from "../../../backend/ConsultaTotvs";
import LoadingSpinner from "../LoadinSpinner";
import { ConsultaAPI } from "../../../backend/ConsultaAPI";

function SelectDinamico({
    label,
    consulta,
    tabela,
    cValue,
    cText,
    isMultiplo,
    EmpresaLogada,
    onchange,
    onblur,
    campoValue,
    showNoFilter = false,
    disabled = false,
    returnOrigem = false,
    minimoInput = 1,
    selectOptionUnique = false,
    bindItem,
    field
}) {
    const optionsRef = useRef([]);
    const initialized = useRef(false);
    const selectRef = useRef(null);

    const debounceRef = useRef(null);
    const ultimoValorBuscadoRef = useRef("");
    const ultimaListaBuscadaRef = useRef([]);

    const [defaultOptions, setDefaultOptions] = useState([]);

    const escapeSqlLike = (value) => {
        return String(value || "")
            .replace(/'/g, "''")
            .replace(/%/g, "[%]")
            .replace(/_/g, "[_]");
    };

    const normalizarCampoSql = (campo) => {
        console.log(campo);
        if (!campo) return "";

        let campoLimpo = String(campo).trim();

        /*
            Converte acesso JS por colchetes:
            item["A1_NOME"]        -> [A1_NOME]
            item["Nome Completo"]  -> [Nome Completo]
            item["SA1.A1_NOME"]    -> [SA1].[A1_NOME]
        */
        campoLimpo = campoLimpo.replace(/\bitem\[['"]([^'"]+)['"]\]/gi, (_, campoInterno) => {
            const campoTrim = String(campoInterno || "").trim();

            if (!campoTrim) return "";

            // Se já vier com colchetes, preserva
            if (campoTrim.startsWith("[") && campoTrim.endsWith("]")) {
                return campoTrim;
            }

            // Se tiver ponto e não tiver espaço, entende como tabela.campo
            // Ex: SA1.A1_NOME -> [SA1].[A1_NOME]
            if (campoTrim.includes(".") && !campoTrim.includes(" ")) {
                return campoTrim
                    .split(".")
                    .map((parte) => `[${parte.trim()}]`)
                    .join(".");
            }

            // Campo simples ou com espaço
            return `[${campoTrim}]`;
        });

        /*
            Remove prefixo item.
            Ex:
            item.A1_NOME.trim() -> A1_NOME.trim()
            item.[Nome Completo] -> [Nome Completo]
        */
       campoLimpo = campoLimpo.replace(/\bitem\./gi, "");
       campoLimpo = campoLimpo.replace("item", "");
       campoLimpo = campoLimpo.replace("Id", "");

        /*
            Remove chamadas JS:
            .trim()
            .toString()
            .toUpperCase()
            .toLowerCase()
            etc.
        */
        campoLimpo = campoLimpo.replace(/\.[a-zA-Z_$][\w$]*\s*\([^)]*\)/g, "");

        /*
            Remove strings fixas de concatenação:
            item.A1_COD + " - " + item.A1_NOME
            vira:
            A1_COD + A1_NOME
        */
        campoLimpo = campoLimpo.replace(/"[^"]*"/g, "");
        campoLimpo = campoLimpo.replace(/'[^']*'/g, "");
        campoLimpo = campoLimpo.replace(/`[^`]*`/g, "");

        // Normaliza espaços ao redor do +
        campoLimpo = campoLimpo.replace(/\s*\+\s*/g, " + ");

        // Remove + sobrando no começo ou no fim
        campoLimpo = campoLimpo.replace(/^(\s*\+\s*)+/, "");
        campoLimpo = campoLimpo.replace(/(\s*\+\s*)+$/, "");

        // Remove + duplicados
        campoLimpo = campoLimpo.replace(/(\+\s*){2,}/g, "+ ");

        /*
            Evita o uso do Campo Codigo na busca da Moeda
        */
        campoLimpo = campoLimpo.replace('CODIGO + X6_CONTEUD', "X6_VAR + X6_CONTEUD");

        /*
            Mantém somente caracteres seguros para o cenário:
            letras, números, underline, +, ponto, colchetes e espaços.
            
            Importante:
            - mantém [Nome Completo]
            - mantém [SA1].[A1_NOME]
        */
        campoLimpo = campoLimpo.replace(/[^a-zA-Z0-9_+\[\].\s]/g, "");

        /*
            Trata cada parte concatenada.
            Preserva campos SQL com colchetes.
        */
        campoLimpo = campoLimpo
            .split("+")
            .map((parte) => {
                let campoParte = parte.trim();

                if (!campoParte) return "";

                // Se tiver colchetes, preserva como está
                if (campoParte.includes("[") && campoParte.includes("]")) {
                    return campoParte;
                }

                // Se vier algo como origem.A1_NOME, pega só A1_NOME
                if (campoParte.includes(".")) {
                    const partes = campoParte.split(".");
                    campoParte = partes[partes.length - 1];
                }

                return campoParte.trim();
            })
            .filter(Boolean)
            .join(" + ");

        return campoLimpo;
    };

    const adicionarFiltroLike = (consultaOriginal, campo, valorDigitado) => {
        if (!consultaOriginal || !campo || !valorDigitado) {
            return consultaOriginal;
        }

        const campoSql = normalizarCampoSql(campo);

        if (!campoSql) {
            return consultaOriginal;
        }

        const valor = escapeSqlLike(valorDigitado);

        const filtro = `${campoSql} LIKE '%${valor.toUpperCase()}%'`;

        const consultaSemPontoVirgula = consultaOriginal.trim().replace(/;$/, "");

        const regexClausulaFinal = /\b(GROUP BY|ORDER BY|HAVING)\b/i;
        const matchClausulaFinal = consultaSemPontoVirgula.match(regexClausulaFinal);

        let partePrincipal = consultaSemPontoVirgula;
        let parteFinal = "";

        if (matchClausulaFinal) {
            const index = matchClausulaFinal.index;

            partePrincipal = consultaSemPontoVirgula.substring(0, index).trim();
            parteFinal = " " + consultaSemPontoVirgula.substring(index).trim();
        }

        const partePrincipalUpper = partePrincipal.toUpperCase();

        const ultimoWhereIndex = partePrincipalUpper.lastIndexOf(" WHERE ");

        if (ultimoWhereIndex >= 0) {
            return `${partePrincipal} AND ${filtro}${parteFinal}`;
        }

        return `${partePrincipal} WHERE ${filtro}${parteFinal}`;
    };

    const handleChangeSelect = (selected) => {
        const isMulti = isMultiplo;

        if (isMulti) {
            if (!Array.isArray(selected) || selected.length === 0) {
                selected = [];
            } 
        } else {
            if (!selected || !optionsRef.current.some((opt) => opt.value === selected.value)) {
                selected = { value: "", label: "Digite para Localizar" };
            }
        }

        if (bindItem && field in bindItem) {
            bindItem[field] = selected;
        }

        if (onchange) {
            onchange(selected, bindItem);
        }
    };

    const fetchOptions = useCallback(async (valorDigitado = "") => {
        if (!consulta) {
            return [];
        }

        try {
            const consultaFiltrada = (consulta === 'Usuario') ? consulta : adicionarFiltroLike(
                consulta,
                cText || cValue,
                valorDigitado
            );

            const retConsulta =
                tabela === "MSSQL"
                    ? await ConsultaAPI(consultaFiltrada)
                    : await ConsultaTotvs(consultaFiltrada, tabela, EmpresaLogada);

            if (retConsulta.data) {
                const newOptions = retConsulta.data.map((item) => {
                    const option = {
                        value: eval("item." + cValue),
                        label: eval("item." + cText),
                    };

                    if (returnOrigem) {
                        option.origem = item;
                    }

                    return option;
                });

                optionsRef.current = newOptions;

                if (showNoFilter || valorDigitado) {
                    setDefaultOptions(newOptions);
                }

                if (selectOptionUnique && newOptions.length === 1) {
                    handleChangeSelect(newOptions[0]);
                }

                return newOptions;
            }

            return [];
        } catch (erro) {
            console.error("Erro ao buscar dados:", erro);
            return [];
        }
    }, [
        consulta,
        tabela,
        EmpresaLogada,
        cValue,
        cText,
        returnOrigem,
        selectOptionUnique,
        showNoFilter
    ]);

    useEffect(() => {
        const loadDefault = async () => {
            await fetchOptions();
        };

        if (showNoFilter) {
            loadDefault();
        }
    }, []);

    useEffect(() => {
        if (selectOptionUnique && consulta) {
            fetchOptions();
        }
    }, [consulta]);

    useEffect(() => {
        if (showNoFilter) {
            fetchOptions();
        }
    }, [consulta, tabela, EmpresaLogada]);

    useEffect(() => {
        const selectedValue = async () => {
            await fetchOptions();

            if (!campoValue?.label?.trim()) {
                if (campoValue?.value) {
                    const selected = optionsRef.current.find((item) => item.value === campoValue?.value);

                    if (typeof selected === "object") {
                        handleChangeSelect(selected);
                    } else {
                        const selectedDefault = { value: "", label: "Digite para Localizar" };
                        handleChangeSelect(selectedDefault);
                    }
                } else {
                    const selectedDefault = { value: "", label: "Digite para Localizar" };
                    onchange(selectedDefault);
                }
            }
        };

        const selectedValueMulti = async () => {
            await fetchOptions();

            if (Array.isArray(campoValue)) {
                const updatedSelected = campoValue.map((sel) => {
                    const match = optionsRef.current.find((opt) => opt.value === sel.value);
                    return match ? { ...sel, label: match.label } : sel;
                });

                onchange(updatedSelected);
            }
        };

        if (initialized.current && isMultiplo) return;

        if (!isMultiplo) {
            if (campoValue && campoValue?.value) {
                if (
                    typeof campoValue?.value === "number" &&
                    campoValue?.value &&
                    !campoValue?.label?.trim()
                ) {
                    selectedValue();
                } else if (
                    typeof campoValue?.value === "string" &&
                    campoValue?.value.trim() &&
                    !campoValue?.label?.trim()
                ) {
                    selectedValue();
                } else if (!campoValue?.label?.trim()) {
                    const selectedDefault = { value: "", label: "Digite para Localizar" };
                    handleChangeSelect(selectedDefault);
                }
            }
        } else {
            if (Array.isArray(campoValue) && campoValue.length > 0) {
                selectedValueMulti();

                initialized.current = true;
            }
        }
    }, [campoValue]);

    useEffect(() => {
        return () => {
            clearTimeout(debounceRef.current);
        };
    }, []);

    const handleInputChange = (value, actionMeta) => {
        if (
            actionMeta?.action === "set-value" ||
            actionMeta?.action === "input-blur" ||
            actionMeta?.action === "menu-close"
        ) {
            return value;
        }

        return value;
    };

    const handleMenuOpen = () => {
        if (showNoFilter && optionsRef.current.length === 0) {
            fetchOptions();
        }
    };

    const loadOptions = (inputValue, callback) => {
        clearTimeout(debounceRef.current);

        const valorDigitado = String(inputValue || "").trim();

        if (!valorDigitado && !showNoFilter) {
            optionsRef.current = [];
            setDefaultOptions([]);
            ultimoValorBuscadoRef.current = "";
            ultimaListaBuscadaRef.current = [];

            callback([]);
            return;
        }

        if (valorDigitado.length < minimoInput && !showNoFilter) {
            callback([]);
            return;
        }

        /**
         * Regra padrão:
         * busca no backend/API com debounce
         */
        debounceRef.current = setTimeout(async () => {
            try {
                if (ultimoValorBuscadoRef.current === valorDigitado) {
                    callback(ultimaListaBuscadaRef.current || []);
                    return;
                }

                ultimoValorBuscadoRef.current = valorDigitado;

                const newOptions = await fetchOptions(valorDigitado);

                const lista = newOptions || [];

                /**
                 * Regra especial para USUARIO:
                 * filtra localmente as opções já carregadas em optionsRef.current
                 */
                if (consulta === "Usuario") {
                    const termo = valorDigitado.toLowerCase();

                    const filtered = lista.filter((i) =>
                        String(i.label || "").toLowerCase().includes(termo)
                    );

                    optionsRef.current = filtered;
                    ultimaListaBuscadaRef.current = filtered;
                    setDefaultOptions(filtered);
                    callback(filtered);
                    return;
                }else{
                    optionsRef.current = lista;
                    ultimaListaBuscadaRef.current = lista;
                    setDefaultOptions(lista);

                    callback(lista);
                }                
            } catch (erro) {
                console.error("Erro ao carregar opções:", erro);
                callback([]);
            }
        }, 600);
    };

    const selectProps = {
        ref: selectRef,
        isMulti: isMultiplo,
        isClearable: true,
        loadOptions,
        placeholder: "Digite para Localizar",
        onChange: (e) => handleChangeSelect(e),
        value: campoValue || bindItem?.[field],
        onInputChange: handleInputChange,
        onBlur: onblur && ((e) => onblur(e)),
        onMenuOpen: handleMenuOpen,
        isDisabled: disabled,
        defaultOptions: defaultOptions
    };

    return (
        <>
            <LoadingSpinner isLoading={false} />

            {!label && (
                <DinamicSelect {...selectProps} />
            )}

            {label && (
                <DivFormGroup>
                    <LabelInput id="inputGroup-sizing-sm" className="input-group-text">
                        {label}
                    </LabelInput>

                    <DivInput>
                        <DinamicSelect {...selectProps} />
                    </DivInput>
                </DivFormGroup>
            )}
        </>
    );
}

export default SelectDinamico;